
import React, { useState } from "react";

const AutoCompleteInput = ({
    label,
    placeHolder="",
    value,
    cssClass,
    labelClass,
    onChange,
    options = [],
    optionKey = "key",
    optionValue = "value",
    onSelect,
    onCreate,
    readOnly=false,
    mWidth = "100%",
}) => {
    const [showList, setShowList] = useState(false);

    const search = (value || "").toLowerCase();

    // Empty value = show all options
    const filtered = options.filter((item) => {
        const key = String(item[optionKey] || "").toLowerCase();
        const val = String(item[optionValue] || "").toLowerCase();

        return key.includes(search) || val.includes(search);
    });

    return (
        <div
            style={{
                position: "relative",
                width: mWidth,
                display: "flex",
                flexDirection: "column",
                verticalAlign: "top",
            }}
        >
            {label && (
                <label
                    htmlFor="search-input"
                    style={{
                        fontSize: "12px",
                        fontWeight: 600,
                        marginBottom: "2px",
                    }}
                    className={labelClass}
                >
                    {label}
                </label>
            )}

            <input
                id="search-input"
                type="text"
                autoComplete="off"
                value={value || ""}
                className={`${cssClass} w-full`}
                placeholder={placeHolder}
                readOnly={readOnly}
                onChange={(e) => {
                    onChange(e.target.value);
                    setShowList(true);
                }}
                onFocus={() => setShowList(true)}
                onBlur={() => setTimeout(() => setShowList(false), 200)}
                style={{
                    width: "100%",
                    padding: "5px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                }}
            />

            {/* Show all options when blank, filtered options when typing */}
            {showList && (
                <div
                    style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        background: "#fff",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                        zIndex: 999,
                        maxHeight: "180px",
                        overflowY: "auto",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                    }}
                >
                    {filtered.length > 0 ? (
                        filtered.map((item, idx) => (
                            <div
                                key={idx}
                                style={{
                                    padding: "8px 10px",
                                    cursor: "pointer",
                                }}
                                onMouseDown={() => {
                                    onSelect?.(item);
                                    onChange(item[optionKey]);
                                    setShowList(false);
                                }}
                            >
                                {item[optionKey]}
                            </div>
                        ))
                    ) : (
                        <div
                            style={{
                                padding: "8px 10px",
                                color: "#999",
                            }}
                        >
                            No options found
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default AutoCompleteInput;
